import React from 'react';
import deepmerge from 'deepmerge';

import oneLineTrim from 'common-tags/lib/oneLineTrim';

import removeMarkdown from 'remove-markdown';

export default function isNotEmptyReactElementContent(element) {
  const isString = typeof(element) === 'string';
  const isNumber = typeof(element) === 'number';
  const isArray = Array.isArray(element);
  const isElement = React.isValidElement(element);

  // Не пустая строка или не пустой массив, или число, или реактовский элемент.
  return (isNumber || isElement || isString && !!element.length || isArray && !!element.filter(Boolean).length);
}

export function replaceSpaces(data) {
  if (Array.isArray(data)) {
    return data.join().replace(/\s/g, '_');
  }
  if (typeof data === 'string') {
    return data.replace(/\s/g, '_');
  }
  return '';
}

/**
 * Утилита трансформирует ссылки в виджете readMore, добавляя к ним UTM-метки.
 *
 * UTM-метки используются для сбора статистики, сравнивая старый и новый дизайн виджета.
 *
 * @author Artyom Gavrilyuk <a.gavrilyuk@rambler-co.ru>
 * @returns {array}
 */
export function transformReadMoreLinks(content) {
  return content.map((c, i) => {
    const link = c.attributes.link;
    return deepmerge(c || {}, {
      attributes: {
        link: `${link}${link.includes('?') ? '&' : '?'}utm_source=readmoreintopic&utm_medium=readmoreoutoftopic${content.length === 1 ? '' : i + 1}&utm_campaign=analytics`,
      },
    });
  });
}

export function getFirstParagraph(widgets) {
  const firstTextWidget = widgets.find(({ type }) => type === 'markdown');
  return firstTextWidget && oneLineTrim`${removeMarkdown(firstTextWidget.attributes.body)}`;
}

/**
 * Берем первые два предложения из первого текстового виджета.
 */
export function getDescription(widgets) {
  const firstParagraph = getFirstParagraph(widgets);
  return firstParagraph && firstParagraph
    .split('.')
    .splice(0, 2)
    .join('.');
}

/**
 * Проверяет, является ли переданная модель моделью `image`.
 * @param {*} model - Модель для проверки.
 * @returns {boolean}
 */
export function isImageModel(model) {
  return !!(model && (model.type === 'image' || model.type === 'video'));
}

/**
 * Функция, проверяющая на видеоформат
 */
export function isVideoMedia(src, url) {
  return (src && src.type === 'video') || /\.(mp4|mov|webm)$/.test(url);
}

/**
 * Преобразует модуль c набором виджетов в объект с компонентами виджетов,
 * который принимает на вход TopicContent
 */
export function prepareWidgetsBlock(module) {
  return Object.keys(module).reduce((blocks, name) => {
    const blockName = name[0].toLowerCase() + name.slice(1);

    const Widget = module[name]; // eslint-disable-line import/namespace

    blocks[blockName] = (block, parentProps, ctx) => (
      <Widget
        block={block}
        parentProps={parentProps}
        ctx={ctx}
      />
    );

    return blocks;
  }, {});
}

/**
 * Проверяет, нужно ли показывать источник фото.
 * @param {string} publishedAt - Дата публикации топика.
 * @returns {boolean} - true, если источник фото должен отображаться.
 */

export const shouldShowPhotoSource = (publishedAt) => {
  const referenceDate = new Date('2024-12-12').getTime();
  return new Date(publishedAt).getTime() < referenceDate;
};
